"use client";
import React, { useEffect, useState } from "react";
import Header from "./Layout/Header";
import Footer from "./Layout/Footer";

export function RenderHtmlFile(props) {
  const [content, setContent] = useState("");

  useEffect(() => {
    // Fetch the HTML content from the file in the public directory
    fetch(props.file_name)
      .then((response) => response.text())
      .then((data) => setContent(data));
  }, []);

  const width = "100%";

  return (
    <div
      dangerouslySetInnerHTML={{ __html: content }}
      style={{
        width: "100%", // Ensures the container takes the full width of its parent
        overflowX: "auto", // Adds a horizontal scroll if content overflows
        padding: "20px", // Adds some padding for readability
        boxSizing: "border-box",
      }}
    />
  );
}

export function RenderHtmlFileWrapper(props) {
  return (
    <>
      <Header noNavigation={true} />
      <div className="container flex items-center justify-center min-h-screen sm:px-4 mx-auto mt-64 mb-64">
        <RenderHtmlFile {...props} />
      </div>
      <Footer />
    </>
  );
}
